export default __webpack_public_path__ + "public/assets/images/4aacdbf36b08321bbb34c3ed6659338a.png";